import type { HTMLAttributes, ReactNode } from 'react'

interface ContainerProps extends HTMLAttributes<HTMLDivElement> {
  children: ReactNode
  size?: 'sm' | 'md' | 'lg' | 'xl' | 'full'
  as?: 'div' | 'section' | 'article' | 'header' | 'footer' | 'nav'
}

const sizeClasses = {
  sm: 'max-w-3xl',     // 768px
  md: 'max-w-5xl',     // 1024px
  lg: 'max-w-6xl',     // 1152px
  xl: 'max-w-[var(--container-yada)]', // 1200px
  full: 'max-w-none',
}

/**
 * Container — max-width wrapper with consistent horizontal padding
 */
export default function Container({
  children,
  size = 'xl',
  as: Tag = 'div',
  className = '',
  ...rest
}: ContainerProps) {
  const classes = [
    'mx-auto w-full px-section-x',
    sizeClasses[size],
    className,
  ]
    .filter(Boolean)
    .join(' ')

  return (
    <Tag className={classes} {...rest}>
      {children}
    </Tag>
  )
}
